import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { FeatureService } from "../../services/feature.service";

export const featureGuard: CanActivateFn = (route, state) => {
  const featureService = inject(FeatureService);
  const router = inject(Router);

  const requiredFeature = route.data["feature"];
  if (featureService.hasFeature(requiredFeature)) {
    return true;
  }

  // Access denied: Redirect to a "Not Authorized" or "Upgrade" page
  console.warn(`Access denied for feature: ${requiredFeature}`);
  return router.parseUrl("/college-admin-dashboard/feature-locked");
};
